(function () {
  function initSwipeVariant() {
    const gallery = document.querySelector('.product__media-wrapper, .product-media-container, [data-product-media-container]');
    if (!gallery) return;

    let startX = 0;
    let startY = 0;
    const THRESHOLD = 50;
    const DEBOUNCE_MS = 300;
    let lastSwipe = 0;

    gallery.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    gallery.addEventListener('touchend', (e) => {
      const now = Date.now();
      if (now - lastSwipe < DEBOUNCE_MS) return;

      const diffX = startX - e.changedTouches[0].clientX;
      const diffY = startY - e.changedTouches[0].clientY;

      // Yatay swipe kontrolü (dikey kaydırmayı engelleme)
      if (Math.abs(diffX) < THRESHOLD || Math.abs(diffX) < Math.abs(diffY)) return;

      lastSwipe = now;

      // Aktif varyant seçeneklerini bul
      const swatches = document.querySelectorAll('input[type="radio"][name*="olor"], input[type="radio"][name*="olor"], .swatch input, fieldset input[type="radio"]');
      if (!swatches.length) return;

      const activeIndex = Array.from(swatches).findIndex(s => s.checked);
      if (activeIndex === -1) return;

      let nextIndex;
      if (diffX > 0) {
        // Sola swipe → sonraki renk
        nextIndex = (activeIndex + 1) % swatches.length;
      } else {
        // Sağa swipe → önceki renk
        nextIndex = (activeIndex - 1 + swatches.length) % swatches.length;
      }

      const nextSwatch = swatches[nextIndex];
      nextSwatch.checked = true;
      nextSwatch.dispatchEvent(new Event('change', { bubbles: true }));
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipeVariant);
  } else {
    initSwipeVariant();
  }
})();
